import React, { Fragment } from 'react';

const LoadingScreen = () => (
  <Fragment>
    <div className="account-pages" />
    <div className="clearfix" />

    <section>
      <div className="container-alt">
        <div className="row">
          <div className="col-sm-12 text-center">
            <div className="home-wrapper" />
          </div>
        </div>
      </div>
    </section>
  </Fragment>
);

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/LoadingScreen/index.js